/**
 * Stato di un ordine del negozio come nel negozio (WooCommerce: un'etichetta; Shopify: pagamento ed
 * evasione). Regole in lib/commerce/storeOrderStatus.ts.
 */
import { STORE_STATUS_TONE_CLASS, type StoreStatusBadge } from '../../../lib/commerce/storeOrderStatus';

export function StoreStatusBadges({ badges, size = 'sm', title }: { badges: StoreStatusBadge[]; size?: 'xs' | 'sm'; title?: string }) {
  const cls = size === 'xs' ? 'px-2 py-0.5 rounded text-[10px]' : 'px-2 py-1 rounded-full text-xs';
  return (
    <span className="inline-flex flex-wrap items-center gap-1" title={title}>
      {badges.map((b) => (
        <span key={b.label} className={`${cls} font-medium whitespace-nowrap ${STORE_STATUS_TONE_CLASS[b.tone]}`}>{b.label}</span>
      ))}
    </span>
  );
}
